import { DataSourceType } from 'automation-ui-formula-editor/data-passing-panel/types/dataSourcesTypes';
/**
 * Determine if the provided property should be allowed based on its dataPropertyType typeDefinition fieldType.
 */
export const isPropertyFieldTypeAllowListed = ({
  dataSourceType,
  property,
  propertyFieldTypeAllowList = []
}) => {
  if (!propertyFieldTypeAllowList || propertyFieldTypeAllowList.length <= 0) {
    return true;
  }

  // narrow down the metadata type so we can figure out what to display
  const {
    dataPropertyType
  } = property;
  if (dataPropertyType === DataSourceType.DATA_FIELDS || dataPropertyType === DataSourceType.CONNECTION) {
    var _property$metadata, _property$metadata2, _property$metadata3;
    const fieldType = (_property$metadata = property.metadata) === null || _property$metadata === void 0 ? void 0 : _property$metadata.typeDefinition.fieldType;

    /* it's both WAD for enum action outputs to not have `fieldType` and for
    non-action-output enums to require a defined `fieldType`. Relax restriction only for
    action outputs with defined options like would be in a custom code action output
    https://git.hubteam.com/HubSpot/ProductSupport/issues/70952 */
    if (dataSourceType === DataSourceType.ACTION_OUTPUT && dataPropertyType === DataSourceType.DATA_FIELDS && ((_property$metadata2 = property.metadata) === null || _property$metadata2 === void 0 ? void 0 : _property$metadata2.typeDefinition.type) === 'enumeration' && ((_property$metadata3 = property.metadata) === null || _property$metadata3 === void 0 ? void 0 : _property$metadata3.typeDefinition.options.length) > 0) {
      return true;
    }

    // Special case phone number fields. Empty fieldTypes can come from Action
    // Outputs. fieldType=text come from single line text fields. Customers want
    // to be able to copy strings directly into phone number fields 🤷.
    if (propertyFieldTypeAllowList.includes('phonenumber') && (!fieldType || fieldType === 'text')) {
      return true;
    }

    // Special case for file fields. For legacy reasons, hs_attachment_ids needs to be allow listed specifically
    // https://hubspot.slack.com/archives/C069MBWR563/p1733938289377139?thread_ts=1733849364.024849&cid=C069MBWR563
    if (propertyFieldTypeAllowList.includes('file') && property.name === 'hs_attachment_ids') {
      return true;
    }
    return propertyFieldTypeAllowList.includes(fieldType !== null && fieldType !== void 0 ? fieldType : 'unknown');
  }
  return true;
};